<template ref="rolecollapse">
    <el-collapse v-model="activeNames">
        <div v-for="(item, index) in list" :key="index">
            <!-- 资源名称 -->
            <!-- <el-row v-if="(Array.isArray(item.authTypes) && item.authTypes.length > 0) || item.children.length > 0"> -->
            <el-row>
                <el-col :span="1">
                    <td-checkbox
                        style="line-height:50px;"
                        v-model="item.checkAll"
                        :sParentId="item.sParentId"
                        :ref="item.resId"
                        @change="
                            val => {
                                handleCheckAllChange(val, index, item);
                            }
                        "
                    ></td-checkbox>
                </el-col>
                <el-col :span="23">
                    <el-collapse-item :title="item.resName" :name="item.resId">
                        <!-- 权限复选框 -->
                        <td-checkbox-group
                            v-if="item.authTypes"
                            :allList="item.authTypes"
                            v-model="item.checkList"
                            keys="authId"
                            text="authName"
                            @handleCheckedChange="
                                (val, checkNewest) => {
                                    handleCheckedGroupChange(val, checkNewest, item);
                                }
                            "
                        ></td-checkbox-group>
                        <tree-collapse
                            :formRoleInfo="formRoleInfo"
                            :list="item.children"
                            :menuId="menuId"
                            :inCollapse="true"
                            @sendCheckList="handleCheckedGroupChange"
                            @sendCheckAllChange="handleCheckAllChange"
                            @setCheckAllBtnStatus="setCheckAllBtnStatus"
                            @checkAllChange="checkAllChange"
                            style="padding: 0 0 0 20px;"
                        ></tree-collapse>
                    </el-collapse-item>
                </el-col>
            </el-row>
        </div>
    </el-collapse>
</template>

<script>
// import resourceApi from '../assets/api.js';
export default {
    props: ['list', 'listAll', 'formRoleInfo', 'outActiveNames', 'inCollapse', 'menuId'],
    name: 'tree-collapse',
    // 定义变量
    created() {
        if (this.inCollapse && this.menuId != 'others') {
            for (let ele in this.list) {
                this.activeNames.push(this.list[ele].resId);
            }
        } else {
            this.activeNames = this.outActiveNames;
        }
    },
    data() {
        return {
            that: this,
            allList: [],
            checkList: [],
            pageInit: true,
            resInitList: [],
            returnList: [],
            activeNames: []
        };
    },
    watch: {
        /* 监听数据的变化，实时生效 */
        list: {
            handler: function(newVal) {
                this.list = newVal;
            },
            deep: true
        }
    },
    methods: {
        //全选反选
        handleCheckAllChange(val, index, data) {
            this.$emit('sendCheckAllChange', val, index, data);
        },
        getAllSelectedItems() {},
        handleCheckedGroupChange(val, checkNewest, data) {
            data.checkList = new Array();
            for (let i = 0; i < val.length; i++) {
                if (data.checkList.indexOf(val[i]) == -1) {
                    data.checkList.push(val[i]);
                }
            }
            this.$emit('sendCheckList', val, checkNewest, data);
        }
    }
};
</script>
